import { t } from '@lingui/core/macro'
import { Button, type ButtonProps } from 'antd'
import type { ComponentProps } from 'react'
import { FaEdit, FaPlus, FaSave } from 'react-icons/fa'
import { twMerge } from 'tailwind-merge'
import { ActionButton } from './ActionButton'

export const EditButton = ({
  size = 'small',
  color = 'default',
  className,
  icon = <FaEdit />,
  ...props
}: ButtonProps) => {
  return <Button icon={icon} size={size} color={color} className={twMerge(className)} {...props} />
}

export const EditSectionButton = ({
  size = 'small',
  color = 'primary',
  shape = 'round',
  className,
  icon = <FaEdit />,
  ...props
}: ButtonProps) => {
  return (
    <Button
      icon={icon}
      size={size}
      color={color}
      shape={shape}
      className={twMerge('text-primary-500!', className)}
      children={t`Bearbeiten`}
      {...props}
    />
  )
}

export const SaveButton = ({
  color = 'primary',
  className,
  icon = <FaSave />,
  shape = 'round',
  ...props
}: ButtonProps) => {
  return (
    <Button
      icon={icon}
      color={color}
      shape={shape}
      className={twMerge('text-primary-500!', className)}
      children={t`Speichern`}
      {...props}
    />
  )
}

export const CreateButton = ({ className, ...props }: ButtonProps) => {
  return (
    <Button
      block
      variant="dashed"
      color="default"
      className={twMerge(`hover:text-primary-500`, className)}
      icon={<FaPlus />}
      children={t`Neu anlegen`}
      {...props}
    />
  )
}

export const AddButton = ({
  color = 'primary',
  className,
  icon = <FaPlus />,
  variant = 'filled',
  ...props
}: ComponentProps<typeof ActionButton>) => {
  return (
    <ActionButton color={color} icon={icon} variant={variant} size="small" className={twMerge(className)} {...props} />
  )
}

export const TabAddButton = ({
  className,
  children,
  icon = <FaPlus />,
  ...otherProps
}: Pick<ButtonProps, 'className' | 'children' | 'icon'>) => {
  return (
    <span
      className={twMerge('flex items-center cursor-pointer mx-2 space-x-2! hover:text-primary-500', className)}
      {...otherProps}
    >
      {icon && <span className={twMerge(children ? 'mr-2' : '')}>{icon}</span>}
      {children}
    </span>
  )
}
